// extracted by mini-css-extract-plugin
module.exports = {"roundButton":"_1_ri6w","icon":"_2PETt5"};